import React from 'react';
import MInput from '../MInput/MInput';
import { FormFieldProps } from 'app/utils/setFieldProps';

interface Props extends FormFieldProps<React.ChangeEvent<HTMLInputElement>, string | number> { 
  innerRef?: React.RefObject<HTMLInputElement>;
  className?: string;
  inputType?: string;
  label: string;
}

const MFormInputView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MInput {...props}></MInput>
  );
};

MFormInputView.displayName = 'MFormInputView';
MFormInputView.defaultProps = {};

export default MFormInputView;
